module.exports = __webpack_public_path__ + "static/img/main2_4.c50ec02c.png";